import React, { useState } from 'react';
import { Download } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ExportButton = ({ 
  endpoint, 
  filename, 
  label = "Export CSV",
  params = {},
  className = ""
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async () => {
    try {
      setLoading(true);
      setError(null);

      // Build query string
      const queryString = new URLSearchParams(params).toString();
      const url = `${BACKEND_URL}${endpoint}${queryString ? `?${queryString}` : ''}`;

      // Download file
      const response = await axios.get(url, {
        responseType: 'blob'
      });

      // Create download link
      const blob = new Blob([response.data], { type: 'text/csv' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename || `export_${Date.now()}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

    } catch (err) {
      console.error('Export error:', err);
      setError('Failed to export data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleExport}
        disabled={loading}
        className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 disabled:bg-gray-400 rounded-lg transition-colors shadow-sm ${className}`}
      >
        <Download size={16} className={loading ? 'animate-bounce' : ''} />
        <span>{loading ? 'Exporting...' : label}</span>
      </button>
      {error && (
        <div className="absolute top-full mt-2 w-48 p-2 text-xs text-red-600 bg-red-50 border border-red-200 rounded shadow-lg">
          {error}
        </div>
      )}
    </div>
  );
};

export default ExportButton;
